var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"queue-info-ballon",class:{'hide-queue-ballon':!_vm.visible}},[_vm._v("Aguarde em breve você será atendido.")])}
var staticRenderFns = []

export { render, staticRenderFns }